import React from 'react';

import type { TRefObject } from '~/src/features/center/InfoBlocks';
import Tab from '~/src/features/center/Tab';

import * as ST from './styled';

export interface IData {
    id: string,
    title: string,
    d: string,
}

interface IProps {
    icons: IData[],
    slotRefs: TRefObject,
}

export const PanelTab: React.FC<IProps> = ({ icons, slotRefs }) => {

    return (
        <ST.GridContainerTabs>
            <ST.Wrapper>
                {icons.map((elem, key) =>
                    <Tab
                        key={elem.id}
                        slotRefs={slotRefs}
                        index={key}
                        {...elem}
                    />)}
            </ST.Wrapper>
        </ST.GridContainerTabs>
    );
};

export default PanelTab;


